import { StreamData } from 'types/streamData'
import { FieldResolver } from '../fieldResolver'
import { Metadata } from '../../adaptor/metadata'

const authorGenderResolver: FieldResolver = (metadata: Metadata) =>
  ({ authorGender: metadata.getAuthorGender() } as StreamData)

export default authorGenderResolver
